import React, { Component } from 'react';
import { connect } from 'react-redux';
import ErrorsView from './Errors.view';

export class ErrorsContainer extends Component {

  constructor(props) {
    super(props);
    this.closeError = this.closeError.bind(this);
  }

  componentDidMount() {
    const { dispatch } = this.props;
    dispatch({
      type: 'FETCH_USERS'
    });
  }

  closeError(index) {
    const { dispatch } = this.props;
    dispatch({
      type: 'CLOSE_ERROR',
      payload: {
        index,
      }
    });
  }

  render() {
    return (<ErrorsView
      {...this.state}
      {...this.props}
      closeError={this.closeError}
    />);
  }

}

function mapStateToProps(state) {
  const { errors } = state;
  return {
    errors: errors.main,
  };
}

export default connect(mapStateToProps)(ErrorsContainer);



// WEBPACK FOOTER //
// ./src/app/modules/Errors/Errors.container.js